import loadable from "@loadable/component";
import { inject } from "mobx-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { RemoteListChildProps } from "../../components/remote/RemoteList.component";
import type {
  BlockFragment,
  CurrentlyPlayingTrackDetailFragment,
  GetCurrentlyPlayingSongsQueryVariables,
} from "@ihr-radioedit/inferno-webapi";
import { LoadMoreFromCursor } from "../../ui";
import type { Store } from "@inferno/renderer-shared-core";

const RecentTrackList = loadable(() => import("./RecentTrack.component"));

interface CurrentTracksProps
  extends RemoteListChildProps<CurrentlyPlayingTrackDetailFragment, GetCurrentlyPlayingSongsQueryVariables> {
  store?: Store;
  block: BlockFragment;
}

export const CurrentTracks = inject("store")(
  ({ data: tracks, hasNext, next, loading, store, block, refresh }: CurrentTracksProps) => {
    useEffect(() => {
      refresh();
    }, [refresh]);

    const { t } = useTranslation();

    if (!store) {
      return null;
    }

    if (!tracks.length) {
      return <div>{t("no_recent_songs")}</div>;
    }

    return (
      <>
        <RecentTrackList
          data={tracks}
          currentTrackId={tracks[0].isCurrentlyPlayingTrack ? tracks[0].trackId : 0}
          block={block}
        />
        <LoadMoreFromCursor hasNext={hasNext} nextFn={next} loading={loading} sectionName="recently_played" />
      </>
    );
  },
);
